import { ImageOff } from 'lucide-react';

export default function ActivityImagePlaceholder() {
  return (
    <div
      data-testid="activity-image-placeholder"
      className="w-[176px] h-[176px] rounded-[12px] bg-pine-hover-item flex flex-col items-center justify-center gap-1 text-pine-ink-soft"
    >
      <ImageOff className="w-6 h-6" />
      <span className="text-xs">No image</span>
    </div>
  );
}
